import React, { PropsWithChildren, ReactElement, useEffect, useState } from 'react';
import { FilterGeneratorProps } from '..';
import { useTranslateWithStringArgs } from 'src/ui/hooks/use-translate';
import FilterRange from '../../filter-popup/filter-range';
import FilterInputOption from '../../filter-popup/filter-input-option';

export type FilterGeneratorNumberProps<Data> = FilterGeneratorProps<Data> & {
  isCurrency?: boolean;
  isPercentage?: boolean;
};

export const FilterGeneratorNumber = <Data,>(
  props: PropsWithChildren<FilterGeneratorNumberProps<Data>>,
): ReactElement | null => {
  const { cellData, isCurrency, isPercentage } = props;

  const translate = useTranslateWithStringArgs();

  const filterLabels = {
    filterName: cellData.filterName || '',
    filterMinValue: `${cellData.filterName}Min`,
    filterMaxValue: `${cellData.filterName}Max`,
  };
  const renderNumberRangeFilter = () => {
    return (
      <FilterRange
        label={cellData.title}
        inputNames={[filterLabels.filterMinValue, filterLabels.filterMaxValue]}
        filterName={filterLabels.filterName}
      >
        <FilterInputOption
          input={filterLabels.filterMinValue}
          defaultField={filterLabels.filterMinValue}
          pairedInput={filterLabels.filterMaxValue}
          type="number"
          isCurrency={isCurrency}
          isPercentage={isPercentage}
          label={null}
          placeholder={translate('common.from')}
          name={filterLabels.filterName}
        />
        <FilterInputOption
          input={filterLabels.filterMaxValue}
          defaultField={filterLabels.filterMaxValue}
          pairedInput={filterLabels.filterMinValue}
          type="number"
          isCurrency={isCurrency}
          isPercentage={isPercentage}
          label={null}
          placeholder={translate('common.to')}
          name={filterLabels.filterName}
        />
      </FilterRange>
    );
  };

  return renderNumberRangeFilter();
};
